import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "about" */ './views/Home.vue'),

    },
    {
      path: '/order/cancel/:id',
      name: 'orderCancel',
      component: () => import(/* webpackChunkName: "about" */ './views/OrderCancel.vue'),
    },
  ],
});
